import { render, staticRenderFns } from "./EventDigitalOnnuri.vue?vue&type=template&id=33e64d7b&"
import script from "./EventDigitalOnnuri.vue?vue&type=script&lang=js&"
export * from "./EventDigitalOnnuri.vue?vue&type=script&lang=js&"
import style0 from "./EventDigitalOnnuri.vue?vue&type=style&index=0&id=33e64d7b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports